import React, { useEffect, useRef, useState } from 'react';
import './welcome.css';
import { AiOutlineSearch, AiOutlineClose } from 'react-icons/ai';
import { fetchProducts } from '../../services/getProducts';
import { useNavigate } from 'react-router-dom';

const SearchContainer = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [products, setProducts] = useState([]);
    const containerRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            { threshold: 0.1 }
        );

        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => {
            if (containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, []);

    useEffect(() => {
        const loadProducts = async () => {
            const data = await fetchProducts();
            setProducts(data);
        };
        loadProducts();
    }, []);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchValue(value);

        if (value.length >= 1) {
            const results = products.filter((product) =>
                product.label.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredProducts(results.slice(0, 5));
        } else {
            setFilteredProducts([]);
        }
    };

    const clearSearch = () => {
        setSearchValue('');
        setFilteredProducts([]);
    };

    const handleProductClick = (id, name) => {
        const productLink = getProductPageLink(id, name);
        navigate(productLink);
    };

    function getProductPageLink(product_id, product_name) {
        const encodedProductName = encodeURIComponent(product_name);
        return `/products/${product_id}-${encodedProductName}`;
    }

    return (
        <div
        >
                <div className='welcome-search-bar-container'>
                    <div className='welcome-search-wrapper'>
                        <input
                            type='text'
                            className='welcome-search-bar'
                            placeholder='Leds, Resistencias...'
                            value={searchValue}
                            autoComplete="off"
                            onChange={handleSearchChange}
                        />
                        <button
                            className='welcome-search-button'
                            onClick={searchValue ? clearSearch : null}
                        >
                            {searchValue ? (
                                <AiOutlineClose className='welcome-search-icon' />
                            ) : (
                                <AiOutlineSearch className='welcome-search-icon' />
                            )}
                        </button>
                        {filteredProducts.length > 0 && (
                            <ul className='welcome-search-results'>
                                {filteredProducts.map((product) => (
                                    <li
                                        key={product.ref}
                                        className='welcome-search-result-item'
                                        onClick={() => handleProductClick(product.id, product.label)}
                                    >
                                        <span className='welcome-product-name'>
                                            {product.label}
                                        </span>
                                        <span className='welcome-product-price'>
                                            ₡{parseFloat(product.price).toFixed(0)}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
        </div>
    );
};

export default SearchContainer;
